module.exports = __webpack_public_path__ + "img/17-4-zh.0a7e1557.png";